// eslint-disable-next-line no-unused-vars
var movesGer = {
    "1": "Klaps",
    "2": "Karateschlag",
    "3": "Duplexhieb",
    "4": "Kometenhieb",
    "5": "Megahieb",
    "6": "Zahltag",
    "7": "Feuerschlag",
    "8": "Eishieb",
    "9": "Donnerschlag",
    "10": "Kratzer",
    "11": "Klammer",
    "12": "Guillotine",
    "13": "Klingensturm",
    "14": "Schwerttanz",
    "15": "Zerschneider",
    "16": "Windsto\u00df",
    "17": "Fl\u00fcgelschlag",
    "18": "Wirbelwind",
    "19": "Fliegen",
    "20": "Klammergriff",
    "21": "Slam",
    "22": "Rankenhieb",
    "23": "Stampfer",
    "24": "Doppelkick",
    "25": "Megakick",
    "26": "Sprungkick",
    "27": "Fegekick",
    "28": "Sandwirbel",
    "29": "Kopfnuss",
    "30": "Hornattacke",
    "31": "Furienschlag",
    "32": "Hornbohrer",
    "33": "Tackle",
    "34": "Bodyslam",
    "35": "Wickel",
    "36": "Bodycheck",
    "37": "Fuchtler",
    "38": "Risikotackle",
    "39": "Rutenschlag",
    "40": "Giftstachel",
    "41": "Duonadel",
    "42": "Nadelrakete",
    "43": "Silberblick",
    "44": "Biss",
    "45": "Heuler",
    "46": "Br\u00fcller",
    "47": "Gesang",
    "48": "Superschall",
    "49": "Ultraschall",
    "50": "Aussetzer",
    "51": "S\u00e4ure",
    "52": "Glut",
    "53": "Flammenwurf",
    "54": "Wei\u00dfnebel",
    "55": "Aquaknarre",
    "56": "Hydropumpe",
    "57": "Surfer",
    "58": "Eisstrahl",
    "59": "Blizzard",
    "60": "Psystrahl",
    "61": "Blubbstrahl",
    "62": "Aurorastrahl",
    "63": "Hyperstrahl",
    "64": "Pikser",
    "65": "Bohrschnabel",
    "66": "\u00dcberroller",
    "67": "Fu\u00dfkick",
    "68": "Konter",
    "69": "Geowurf",
    "70": "St\u00e4rke",
    "71": "Absorber",
    "72": "Megasauger",
    "73": "Egelsamen",
    "74": "Wachstum",
    "75": "Rasierblatt",
    "76": "Solarstrahl",
    "77": "Giftpuder",
    "78": "Stachelspore",
    "79": "Schlafpuder",
    "80": "Bl\u00e4ttertanz",
    "81": "Fadenschuss",
    "82": "Drachenwut",
    "83": "Feuerwirbel",
    "84": "Donnerschock",
    "85": "Donnerblitz",
    "86": "Donnerwelle",
    "87": "Donner",
    "88": "Steinwurf",
    "89": "Erdbeben",
    "90": "Geofissur",
    "91": "Schaufler",
    "92": "Toxin",
    "93": "Konfusion",
    "94": "Psychokinese",
    "95": "Hypnose",
    "96": "Meditation",
    "97": "Agilit\u00e4t",
    "98": "Ruckzuckhieb",
    "99": "Raserei",
    "100": "Teleport",
    "101": "Nachtnebel",
    "102": "Mimikry",
    "103": "Kreideschrei",
    "104": "Doppelteam",
    "105": "Genesung",
    "106": "H\u00e4rtner",
    "107": "Komprimator",
    "108": "Rauchwolke",
    "109": "Konfusstrahl",
    "110": "Panzerschutz",
    "111": "Einigler",
    "112": "Barriere",
    "113": "Lichtschild",
    "114": "Dunkelnebel",
    "115": "Reflektor",
    "116": "Energiefokus",
    "117": "Geduld",
    "118": "Metronom",
    "119": "Spiegeltrick",
    "120": "Finale",
    "121": "Eierbombe",
    "122": "Schlecker",
    "123": "Smog",
    "124": "Schlammbad",
    "125": "Knochenkeule",
    "126": "Feuersturm",
    "127": "Kaskade",
    "128": "Schnapper",
    "129": "Sternschauer",
    "130": "Sch\u00e4delwumme",
    "131": "Dornkanone",
    "132": "Umklammerung",
    "133": "Amnesie",
    "134": "Psykraft",
    "135": "Weichei",
    "136": "Turmkick",
    "137": "Schlangenblick",
    "138": "Traumfresser",
    "139": "Giftwolke",
    "140": "Stakkato",
    "141": "Blutsauger",
    "142": "Todeskuss",
    "143": "Himmelsfeger",
    "144": "Wandler",
    "145": "Blubber",
    "146": "Irrschlag",
    "147": "Pilzspore",
    "148": "Blitz",
    "149": "Psywelle",
    "150": "Platscher",
    "151": "S\u00e4urepanzer",
    "152": "Krabbhammer",
    "153": "Explosion",
    "154": "Kratzfurie",
    "155": "Knochmerang",
    "156": "Erholung",
    "157": "Steinhagel",
    "158": "Hyperzahn",
    "159": "Sch\u00e4rfer",
    "160": "Umwandlung",
    "161": "Triplette",
    "162": "Superzahn",
    "163": "Schlitzer",
    "164": "Delegator",
    "165": "Verzweifler",
    "166": "Nachahmer",
    "167": "Dreifachkick",
    "168": "Raub",
    "169": "Spinnennetz",
    "170": "Willensleser",
    "171": "Nachtmahr",
    "172": "Flammenrad",
    "173": "Schnarcher",
    "174": "Fluch",
    "175": "Dreschflegel",
    "176": "Umwandlung 2",
    "177": "Luftsto\u00df",
    "178": "Baumwollsaat",
    "179": "Gegenschlag",
    "180": "Groll",
    "181": "Pulverschnee",
    "182": "Schutzschild",
    "183": "Tempohieb",
    "184": "Grimasse",
    "185": "Finte",
    "186": "Bitterkuss",
    "187": "Bauchtrommel",
    "188": "Matschbombe",
    "189": "Lehmschelle",
    "190": "Octazooka",
    "191": "Stachler",
    "192": "Blitzkanone",
    "193": "Scharfblick",
    "194": "Abgangsbund",
    "195": "Abgesang",
    "196": "Eissturm",
    "197": "Scanner",
    "198": "Knochenhatz",
    "199": "Zielschuss",
    "200": "Wutanfall",
    "201": "Sandsturm",
    "202": "Gigasauger",
    "203": "Ausdauer",
    "204": "Charme",
    "205": "Walzer",
    "206": "Trugschlag",
    "207": "Angeberei",
    "208": "Milchgetr\u00e4nk",
    "209": "Funkensprung",
    "210": "Zornklinge",
    "211": "Stahlfl\u00fcgel",
    "212": "Horrorblick",
    "213": "Anziehung",
    "214": "Schlafrede",
    "215": "Vitalglocke",
    "216": "R\u00fcckkehr",
    "217": "Geschenk",
    "218": "Frustration",
    "219": "Bodyguard",
    "220": "Leidteiler",
    "221": "L\u00e4uterfeuer",
    "222": "Intensit\u00e4t",
    "223": "Wuchtschlag",
    "224": "Vielender",
    "225": "Feuerodem",
    "226": "Stafette",
    "227": "Zugabe",
    "228": "Verfolgung",
    "229": "Turbodreher",
    "230": "Lockduft",
    "231": "Eisenschweif",
    "232": "Metallklaue",
    "233": "\u00dcberwurf",
    "234": "Morgengrauen",
    "235": "Synthese",
    "236": "Mondschein",
    "237": "Kraftreserve",
    "238": "Kreuzhieb",
    "239": "Windhose",
    "240": "Regentanz",
    "241": "Sonnentag",
    "242": "Knirscher",
    "243": "Spiegelcape",
    "244": "Psycho-Plus",
    "245": "Turbotempo",
    "246": "Antik-Kraft",
    "247": "Spukball",
    "248": "Seher",
    "249": "Zertr\u00fcmmerer",
    "250": "Whirlpool",
    "251": "Pr\u00fcgler",
    "252": "Mogelhieb",
    "253": "Aufruhr",
    "254": "Horter",
    "255": "Entfessler",
    "256": "Verzehrer",
    "257": "Hitzewelle",
    "258": "Hagelsturm",
    "259": "Folterknecht",
    "260": "Schmeichler",
    "261": "Irrlicht",
    "262": "Memento-Mori",
    "263": "Fassade",
    "264": "Power-Punch",
    "265": "Riechsalz",
    "266": "Spotlight",
    "267": "Natur-Kraft",
    "268": "Ladevorgang",
    "269": "Verh\u00f6hner",
    "270": "Rechte Hand",
    "271": "Trickbetrug",
    "272": "Rollenspiel",
    "273": "Wunschtraum",
    "274": "Zuschuss",
    "275": "Verwurzler",
    "276": "Kraftkoloss",
    "277": "Magiemantel",
    "278": "Aufbereitung",
    "279": "Vergeltung",
    "280": "Durchbruch",
    "281": "G\u00e4hner",
    "282": "Abschlag",
    "283": "Notsituation",
    "284": "Eruption",
    "285": "F\u00e4higkeitstausch",
    "286": "Begrenzer",
    "287": "Heilung",
    "288": "Nachspiel",
    "289": "\u00dcbernahme",
    "290": "Geheimpower",
    "291": "Taucher",
    "292": "Armsto\u00df",
    "293": "Tarnung",
    "294": "Schweifglanz",
    "295": "Scheinwerfer",
    "296": "Nebelball",
    "297": "Daunenreigen",
    "298": "Taumeltanz",
    "299": "Feuerfeger",
    "300": "Lehmsuhler",
    "301": "Frostbeule",
    "302": "Nietenranke",
    "303": "Tagedieb",
    "304": "Schallwelle",
    "305": "Giftzahn",
    "306": "Zermalmklaue",
    "307": "Lohekanonade",
    "308": "Aquahaubitze",
    "309": "Sternenhieb",
    "310": "Erstauner",
    "311": "Meteorologe",
    "312": "Aromakur",
    "313": "Trugtr\u00e4ne",
    "314": "Windschnitt",
    "315": "Hitzekoller",
    "316": "Schn\u00fcffler",
    "317": "Felsgrab",
    "318": "Silberhauch",
    "319": "Metallsound",
    "320": "Grasfl\u00f6te",
    "321": "Spa\u00dfkanone",
    "322": "Kosmik-Kraft",
    "323": "Fontr\u00e4nen",
    "324": "Ampelleuchte",
    "325": "Finsterfaust",
    "326": "Sondersensor",
    "327": "Himmelhieb",
    "328": "Sandgrab",
    "329": "Eisesk\u00e4lte",
    "330": "Lehmbr\u00fche",
    "331": "Kugelsaat",
    "332": "Aero-Ass",
    "333": "Eisspeer",
    "334": "Eisenabwehr",
    "335": "R\u00fcckentzug",
    "336": "Jauler",
    "337": "Drachenklaue",
    "338": "Flora-Statue",
    "339": "Protzer",
    "340": "Sprungfeder",
    "341": "Lehmschuss",
    "342": "Giftschweif",
    "343": "Bezirzer",
    "344": "Volttackle",
    "345": "Zauberblatt",
    "346": "Nassmacher",
    "347": "Gedankengut",
    "348": "Laubklinge",
    "349": "Drachentanz",
    "350": "Felswurf",
    "351": "Schockwelle",
    "352": "Aquawelle",
    "353": "Kismetwunsch",
    "354": "Psyschub",
    "355": "Ruheort",
    "356": "Erdanziehung",
    "357": "Wunderauge",
    "358": "Weckruf",
    "359": "Hammerarm",
    "360": "Gyroball",
    "361": "Heilopfer",
    "362": "Lake",
    "363": "Beerenkr\u00e4fte",
    "364": "Offenlegung",
    "365": "Pfl\u00fccker",
    "366": "R\u00fcckenwind",
    "367": "Akupressur",
    "368": "Metallsto\u00df",
    "369": "Kehrtwende",
    "370": "Nahkampf",
    "371": "Gegensto\u00df",
    "372": "Gewissheit",
    "373": "Itemsperre",
    "374": "Schleuder",
    "375": "Psybann",
    "376": "Trumpfkarte",
    "377": "Heilblockade",
    "378": "Auswringen",
    "379": "Krafttrick",
    "380": "Magens\u00e4fte",
    "381": "Beschw\u00f6rung",
    "382": "Egotrip",
    "383": "Imitator",
    "384": "Krafttausch",
    "385": "Schutztausch",
    "386": "Strafattacke",
    "387": "Zuflucht",
    "388": "Sorgensamen",
    "389": "Tiefschlag",
    "390": "Giftspitzen",
    "391": "Statustausch",
    "392": "Wasserring",
    "393": "Magnetflug",
    "394": "Flammenblitz",
    "395": "Kraftwelle",
    "396": "Aurasph\u00e4re",
    "397": "Steinpolitur",
    "398": "Gifthieb",
    "399": "Finsteraura",
    "400": "Nachthieb",
    "401": "Nassschweif",
    "402": "Samenbomben",
    "403": "Luftschnitt",
    "404": "Kreuzschere",
    "405": "K\u00e4fergebrumm",
    "406": "Drachenpuls",
    "407": "Drachensto\u00df",
    "408": "Juwelenkraft",
    "409": "Ableithieb",
    "410": "Vakuumwelle",
    "411": "Fokussto\u00df",
    "412": "Energieball",
    "413": "Sturzflug",
    "414": "Erdkr\u00e4fte",
    "415": "Wechseldich",
    "416": "Gigasto\u00df",
    "417": "R\u00e4nkeschmied",
    "418": "Patronenhieb",
    "419": "Lawine",
    "420": "Eissplitter",
    "421": "Dunkelklaue",
    "422": "Donnerzahn",
    "423": "Eiszahn",
    "424": "Feuerzahn",
    "425": "Schattensto\u00df",
    "426": "Schlammbombe",
    "427": "Psychoklinge",
    "428": "Zen-Kopfsto\u00df",
    "429": "Spiegelsalve",
    "430": "Lichtkanone",
    "431": "Kraxler",
    "432": "Auflockern",
    "433": "Bizarroraum",
    "434": "Draco Meteor",
    "435": "Ladungssto\u00df",
    "436": "Flammensturm",
    "437": "Bl\u00e4ttersturm",
    "438": "Blattgei\u00dfel",
    "439": "Felswerfer",
    "440": "Giftstreich",
    "441": "M\u00fclltreffer",
    "442": "Eisensch\u00e4del",
    "443": "Magnetbombe",
    "444": "Steinkante",
    "445": "Liebreiz",
    "446": "Tarnsteine",
    "447": "Strauchler",
    "448": "Geschw\u00e4tz",
    "449": "Urteilskraft",
    "450": "K\u00e4ferbiss",
    "451": "Ladestrahl",
    "452": "Holzhammer",
    "453": "Wasserd\u00fcse",
    "454": "Schlagbefehl",
    "455": "Blockbefehl",
    "456": "Heilbefehl",
    "457": "Kopfsto\u00df",
    "458": "Doppelschlag",
    "459": "Zeitenl\u00e4rm",
    "460": "Raumschlag",
    "461": "Lunartanz",
    "462": "Quetschgriff",
    "463": "Lavasturm",
    "464": "Schlummerort",
    "465": "Schocksamen",
    "466": "Unheilb\u00f6en",
    "467": "Schemenkraft",
    "468": "Klauenwetzer",
    "469": "Rundumschutz",
    "470": "Schutzteiler",
    "471": "Kraftteiler",
    "472": "Wunderraum",
    "473": "Psychoschock",
    "474": "Giftschock",
    "475": "Autotomie",
    "476": "Wutpulver",
    "477": "Telekinese",
    "478": "Magieraum",
    "479": "Katapult",
    "480": "Bergsturm",
    "481": "Funkenflug",
    "482": "Schlammwoge",
    "483": "Falterreigen",
    "484": "Rammboss",
    "485": "Synchrol\u00e4rm",
    "486": "Elektroball",
    "487": "\u00dcberflutung",
    "488": "Nitroladung",
    "489": "Einrollen",
    "490": "Fu\u00dftritt",
    "491": "S\u00e4urespeier",
    "492": "Schmarotzer",
    "493": "Wankelstrahl",
    "494": "Zwango",
    "495": "Galanterie",
    "496": "Kanon",
    "497": "Widerhall",
    "498": "Zerm\u00fcrben",
    "499": "Kl\u00e4rsmog",
    "500": "Kraftvorrat",
    "501": "Rapidschutz",
    "502": "Seitentausch",
    "503": "Siedewasser",
    "504": "Hausbruch",
    "505": "Heilwoge",
    "506": "B\u00fcrde",
    "507": "Freier Fall",
    "508": "Gangwechsel",
    "509": "\u00dcberkopfwurf",
    "510": "Ein\u00e4schern",
    "511": "Verz\u00f6gerung",
    "512": "Akrobatik",
    "513": "Typenspiegel",
    "514": "Heimzahlung",
    "515": "Wagemut",
    "516": "Offerte",
    "517": "Inferno",
    "518": "Wassers\u00e4ulen",
    "519": "Feuers\u00e4ulen",
    "520": "Pflanzens\u00e4ulen",
    "521": "Voltwechsel",
    "522": "K\u00e4fertrutz",
    "523": "Dampfwalze",
    "524": "Eisesodem",
    "525": "Drachenrute",
    "526": "Kraftschub",
    "527": "Elektronetz",
    "528": "Stromsto\u00df",
    "529": "Schlagbohrer",
    "530": "Doppelhieb",
    "531": "Herzstempel",
    "532": "Holzgeweih",
    "533": "Sanctoklinge",
    "534": "Kalkklinge",
    "535": "Brandstempel",
    "536": "Grasmixer",
    "537": "Quetschwalze",
    "538": "Watteschild",
    "539": "Nachtflut",
    "540": "Psychosto\u00df",
    "541": "Kehrschelle",
    "542": "Orkan",
    "543": "Steinsch\u00e4del",
    "544": "Klikkdiskus",
    "545": "Flammenball",
    "546": "Techblaster",
    "547": "Urgesang",
    "548": "Mystoschwert",
    "549": "Eiszeit",
    "550": "Blitzschlag",
    "551": "Blauflammen",
    "552": "Feuerreigen",
    "553": "Frostvolt",
    "554": "Frosthauch",
    "555": "Standpauke",
    "556": "Eiszapfhagel",
    "557": "V-Generator",
    "558": "Kreuzflamme",
    "559": "Kreuzdonner",
    "560": "Flying Press",
    "561": "Tatami-Schild",
    "562": "R\u00fclpser",
    "563": "Pfl\u00fcger",
    "564": "Klebenetz",
    "565": "Stachelfinale",
    "566": "Phantomkraft",
    "567": "Halloween",
    "568": "Kampfgebr\u00fcll",
    "569": "Plasmaschauer",
    "570": "Parabolladung",
    "571": "Waldesfluch",
    "572": "Bl\u00fctenwirbel",
    "573": "Gefriertrockner",
    "574": "S\u00e4uselstimme",
    "575": "Abgangstirade",
    "576": "Invertigo",
    "577": "Diebeskuss",
    "578": "Trickschutz",
    "579": "Floraschutz",
    "580": "Grasfeld",
    "581": "Nebelfeld",
    "582": "Elektrifizierung",
    "583": "Knuddler",
    "584": "Feenbrise",
    "585": "Mondgewalt",
    "586": "\u00dcberschallknall",
    "587": "Feenschloss",
    "588": "K\u00f6nigsschild",
    "589": "Kameradschaft",
    "590": "Vertrauenssache",
    "591": "Diamantsturm",
    "592": "Dampfschwall",
    "593": "Dimensionsloch",
    "594": "Wasser-Shuriken",
    "595": "Magieflamme",
    "596": "Schutzstacheln",
    "597": "Duftwolke",
    "598": "Mystowellen",
    "599": "Giftfalle",
    "600": "Pulverschleuder",
    "601": "Geokontrolle",
    "602": "Magnetregler",
    "603": "Goldene Zeiten",
    "604": "Elektrofeld",
    "605": "Zauberschein",
    "606": "Ehrentag",
    "607": "H\u00e4ndchenhalten",
    "608": "Kulleraugen",
    "609": "Wangenrubbler",
    "610": "Zur\u00fcckhaltung",
    "611": "Plage",
    "612": "Steigerungshieb",
    "613": "Unheilsschwingen",
    "614": "Tausend Pfeile",
    "615": "Tausend Wellen",
    "616": "Bodengewalt",
    "617": "Lux Calamitatis",
    "618": "Ursprungswoge",
    "619": "Abgrundsklinge",
    "620": "Zenitst\u00fcrmer",
    "621": "Dimensionswahn",
    "622": "Hyper-Sprintangriff",
    "623": "Hyper-Sprintangriff",
    "624": "Fulminante Faustschl\u00e4ge",
    "625": "Fulminante Faustschl\u00e4ge",
    "626": "Finaler Steilflug",
    "627": "Finaler Steilflug",
    "628": "Vernichtender S\u00e4ureregen",
    "629": "Vernichtender S\u00e4ureregen",
    "630": "Seismische Eruption",
    "631": "Seismische Eruption",
    "632": "Apokalyptische Steinpresse",
    "633": "Apokalyptische Steinpresse",
    "634": "Wirbelnder Insektenhieb",
    "635": "Wirbelnder Insektenhieb",
    "636": "Ewige Nacht",
    "637": "Ewige Nacht",
    "638": "Turbo-Spiralkombo",
    "639": "Turbo-Spiralkombo",
    "640": "Dynamische Maxiflamme",
    "641": "Dynamische Maxiflamme",
    "642": "Super-Wassertornado",
    "643": "Super-Wassertornado",
    "644": "Brillante Bl\u00fctenpracht",
    "645": "Brillante Bl\u00fctenpracht",
    "646": "Gigavolt-Funkensalve",
    "647": "Gigavolt-Funkensalve",
    "648": "Psycho-Schmetterschlag",
    "649": "Psycho-Schmetterschlag",
    "650": "Tobender Geofrost",
    "651": "Tobender Geofrost",
    "652": "Drastisches Drachendr\u00f6hnen",
    "653": "Drastisches Drachendr\u00f6hnen",
    "654": "Schwarzes Loch des Grauens",
    "655": "Schwarzes Loch des Grauens",
    "656": "Entz\u00fcckender Sternensto\u00df",
    "657": "Entz\u00fcckender Sternensto\u00df",
    "658": "Perfektes Pika-Projektil",
    "659": "Sandsammler",
    "660": "\u00dcberrumpler",
    "661": "Bunker",
    "662": "Schattenfessel",
    "663": "Dark Lariat",
    "664": "Schaumserenade",
    "665": "Eishammer",
    "666": "Florakur",
    "667": "Pferdest\u00e4rke",
    "668": "Kraftabsorber",
    "669": "Solarklinge",
    "670": "Blattwerk",
    "671": "Rampenlicht",
    "672": "Giftfaden",
    "673": "Konzentration",
    "674": "Hilfsmechanik",
    "675": "Neck Strike",
    "676": "Pollenkn\u00f6del",
    "677": "Ankerschuss",
    "678": "Psychofeld",
    "679": "Anfallen",
    "680": "Feuerpeitsche",
    "681": "\u00dcberheblichkeit",
    "682": "Ausbrennen",
    "683": "Initiativetausch",
    "684": "Schmalhorn",
    "685": "L\u00e4uterung",
    "686": "Wecktanz",
    "687": "Sanktionskern",
    "688": "Tropenkick",
    "689": "Kommando",
    "690": "Schnabelkanone",
    "691": "Schuppenrasseln",
    "692": "Drachenhammer",
    "693": "Wirbler",
    "694": "Auroraschleier",
    "695": "Schatten-Pfeilregen",
    "696": "Hyper Dark Crusher",
    "697": "Grandiose Meeressymphonie",
    "698": "Alolas W\u00e4chter",
    "699": "Sternbild des Seelenraubes",
    "700": "Blitz-Wellenritt",
    "701": "Schluss mit lustig",
    "702": "Macht der Neun",
    "703": "Supernova des Ursprungs",
    "704": "Panzerfalle",
    "705": "Kanonenbouquet",
    "706": "Psychobei\u00dfer",
    "707": "Fruststampfer",
    "708": "Schattenknochen",
    "709": "Turbofelsen",
    "710": "Aquadurchsto\u00df",
    "711": "Prisma-Laser",
    "712": "Diebesschatten",
    "713": "Stahlgestirn",
    "714": "Schattenstrahl",
    "715": "Tr\u00e4nendr\u00fcse",
    "716": "Elektropikser",
    "717": "Naturzorn",
    "718": "Multi-Angriff",
    "719": "Tausendfacher Donnerblitz",
    "720": "Knallkopf",
    "721": "Plasmaf\u00e4uste",
    "722": "Photonen-Geysir",
    "723": "Licht des Erl\u00f6schens",
    "724": "Schmetternde Sonnenwalze",
    "725": "Geballter Mondlaser",
    "726": "Herzliche Knuddelkloppe",
    "727": "Fataler Steinregen",
    "728": "Rasselnder Seelentanz",
    "729": "Britzelturbo",
    "730": "Pl\u00e4tschersurfer",
    "731": "Schwebesturz",
    "732": "Pika-Flash",
    "733": "Blubbsauger",
    "734": "Knisterladung",
    "735": "Flackerbrand",
    "736": "Pulsieraura",
    "737": "Qu\u00e4lzone",
    "738": "Sprie\u00dfbomben",
    "739": "Klirrfrost",
    "740": "Glitzersturm",
    "741": "Evo-Crash",
    "742": "Panzerf\u00e4uste",
    "743": "Dyna-Wall",
    "744": "Dynamax-Kanone",
    "745": "Pr\u00e4zisionsschuss",
    "746": "Fesselbiss",
    "747": "Backenstopfer",
    "748": "Finalformation",
    "749": "Teerschuss",
    "750": "Magiepuder",
    "751": "Drachenpfeile",
    "752": "Teatime",
    "753": "Octoklammer",
    "754": "Schockschnabel",
    "755": "Kiemenbiss",
    "756": "Seitenwechsel",
    "757": "Dyna-Brand",
    "758": "Dyna-Schwarm",
    "759": "Dyna-Gewitter",
    "760": "Dyna-Angriff",
    "761": "Dyna-Faust",
    "762": "Dyna-Spuk",
    "763": "Dyna-Frost",
    "764": "Dyna-Giftschwall",
    "765": "Dyna-Flut",
    "766": "Dyna-D\u00fcse",
    "767": "Dyna-Zauber",
    "768": "Dyna-Wyrm",
    "769": "Dyna-Kinese",
    "770": "Dyna-Brocken",
    "771": "Dyna-Erdsto\u00df",
    "772": "Dyna-Dunkel",
    "773": "Dyna-Flora",
    "774": "Dyna-Stahlzacken",
    "775": "Seelentanz",
    "776": "Body Press",
    "777": "Verzierung",
    "778": "Trommelschl\u00e4ge",
    "779": "Fangeisen",
    "780": "Feuerball",
    "781": "Gigantenhieb",
    "782": "Gigantensto\u00df",
    "783": "Aura-Rad",
    "784": "Breitseite",
    "785": "Zweigsto\u00df",
    "786": "Overdrive",
    "787": "Apfels\u00e4ure",
    "788": "Gravitation",
    "789": "Seelenbruch",
    "790": "Wunderdampf",
    "791": "Lebenstropfen",
    "792": "Abblocker",
    "793": "Kniefalltrick",
    "794": "Sternensturm",
    "795": "Unendynastrahlen",
    "796": "Stahlstrahl",
    "797": "Fl\u00e4chenmacht",
    "798": "Eisenwalze",
    "799": "Schuppenschuss",
    "800": "Meteorstrahl",
    "801": "Muschelwaffe",
    "802": "Nebelexplosion",
    "803": "Grasrutsche",
    "804": "Hochspannung",
    "805": "Feldimpuls",
    "806": "Krabbelkracher",
    "807": "Neidflammen",
    "808": "Frustventil",
    "809": "Poltergeist",
    "810": "Korrosionsgas",
    "811": "Coaching",
    "812": "Rollwende",
    "813": "Dreifach-Axel",
    "814": "Doppelfl\u00fcgel",
    "815": "Brandsand",
    "816": "Dschungelheilung",
    "817": "Finstertreffer",
    "818": "Trefferschwall",
    "819": "Blitzgef\u00e4ngnis",
    "820": "Drachenkr\u00e4fte",
    "821": "Eisiger Blick",
    "822": "Brennender Zorn",
    "823": "Donnernder Tritt",
    "824": "Blizzardlanze",
    "825": "Astralfragmente",
    "826": "Schauderspruch",
    "827": "Unheilsklauen",
    "828": "Barrierensto\u00df",
    "829": "Kraftwechsel",
    "830": "Felsaxt",
    "831": "Fr\u00fchlingsorkan",
    "832": "Mythenkraft",
    "833": "Flammenwut",
    "834": "Wellentackle",
    "835": "Chlorostrahl",
    "836": "Frostfallwind",
    "837": "Siegestanz",
    "838": "Schmetterramme",
    "839": "Giftstachelregen",
    "840": "Auraschwingen",
    "841": "Niedertracht",
    "842": "Refugium",
    "843": "Drillingspfeile",
    "844": "Phantomparade",
    "845": "Klingenschwall",
    "846": "Polarorkan",
    "847": "Donnerorkan",
    "848": "W\u00fcstenorkan",
    "849": "Lunargebet",
    "850": "Mutschub",
    "851": "Tera-Ausbruch",
    "852": "Fadenfalle",
    "853": "Fersenkick",
    "854": "Letzte Ehre",
    "855": "Lichteinschlag",
    "856": "Auftischen",
    "857": "D\u00fcsenhieb",
    "858": "Chili-Essenz",
    "859": "Reifendrehung",
    "860": "M\u00e4useplage",
    "861": "Eiskreisel",
    "862": "Gro\u00dfklingensto\u00df",
    "863": "Vitalsegen",
    "864": "P\u00f6kelsalz",
    "865": "Tauchtriade",
    "866": "Letalwirbler",
    "867": "Abpausen",
    "868": "Abspaltung",
    "869": "Kniefallspalter",
    "870": "Blumentrick",
    "871": "Loderlied",
    "872": "Wogentanz",
    "873": "Rasender Stier",
    "874": "Goldrausch",
    "875": "Psychoschneide",
    "876": "Hydrodampf",
    "877": "Verderben",
    "878": "Kollisionskurs",
    "879": "Blitztour",
    "880": "Schwanzabwurf",
    "881": "Eisige Stimmung",
    "882": "Aufr\u00e4umen",
    "883": "Schneelandschaft",
    "884": "Anspringen",
    "885": "Wegbereiter",
    "886": "Kalte Dusche",
    "887": "Hyperbohrer",
    "888": "Doppelstrahl",
    "889": "Zornesfaust",
    "890": "R\u00fcstungskanone",
    "891": "Reueschwert",
    "892": "Zweifachladung",
    "893": "Riesenhammer",
    "894": "Vendetta",
    "895": "Aquaschnitt",
    "896": "Hitzeturbo",
    "897": "Finsterturbo",
    "898": "Toxiturbo",
    "899": "Raufturbo",
    "900": "Zauberturbo",
    "901": "Blutmond",
    "902": "Quirlschuss",
    "903": "Sirupbombe",
    "904": "Rankenkeule",
    "905": "Stromstrahl",
    "906": "Tera-Sternhagel",
    "907": "Launenlaser",
    "908": "Flammenschild",
    "909": "Sturmblitz",
    "910": "Wuchtklinge",
    "911": "Tachyon-Schnitt",
    "912": "Stahlpresse",
    "913": "Drachenschrei",
    "914": "Lockstimme",
    "915": "Frustflamme",
    "916": "Donnersto\u00df",
    "917": "Psychol\u00e4rm",
    "918": "Schnellkonter"
}
export default movesGer;